import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useSaveContext } from '../../contexts/SaveContext'
import {
  Bars3Icon,
  AdjustmentsHorizontalIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline'

import ShareButton from './ShareButton'
import PermissionsSettings from './PermissionsSettings'
import UserMenu from './UserMenu'
import SaveButton from './SaveButton'
import logo from '../../assets/logo.svg'
import PreviewToggleButton from './PreviewToggleButton'

export default function TopNavigation({ onOpenLibrary, onOpenUtilities, recipeCardRef }) {
  const { onSave, isSaved } = useSaveContext()

  return (
    <header
      className="fixed top-0 inset-x-0 z-30
                 h-auto min-h-14 md:min-h-16
                 bg-very-light-gray shadow-md
                 flex items-center justify-between
                 overflow-visible
                 px-2 sm:px-4 gap-x-1 sm:gap-x-2"
    >
      {/* ☰ Mobile - Open Library */}
      <button
        onClick={onOpenLibrary}
        className="md:hidden p-1.5 sm:p-2 py-3 h-11 rounded flex-shrink-0 hover:bg-soft-yellow/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
        aria-label="Open recipe library"
        title="Open recipe library"
      >
        <Bars3Icon className="h-5 w-5 sm:h-6 sm:w-6" />
      </button>

      {/* 🏷 Brand Logo */}
      <Link
        to="/dashboard"
        className="flex flex-col sm:flex-row items-center sm:items-center gap-0.5 sm:gap-1 group text-center sm:text-left"
        aria-label="Ruoth dashboard"
        title="Go to dashboard"
      >
        <img
          src={logo}
          alt="Ruoth Logo"
          className="h-6 sm:h-8 w-auto transition-transform duration-150 group-hover:scale-105"
        />
        <span className="font-marketing text-xs sm:text-sm font-semibold tracking-tight text-deep-blue transition-colors duration-150 group-hover:text-rich-gold leading-tight">
          Workspace
        </span>
      </Link>

      <div className="flex items-center gap-[6px] sm:gap-2 ml-auto flex-shrink-0">
        {/* 💾 Save */}
        <div className="min-w-[64px] sm:min-w-[72px] flex-shrink-0">
          <SaveButton onClick={onSave} isSaved={isSaved} />
        </div>

        {/* 👁 Edit/Preview Toggle */}
        <button className="p-1.5 sm:p-2 py-3 h-11 flex-shrink-0">
          <PreviewToggleButton />
        </button>

        {/* 🔗 Share and export */}
        <div className="flex-shrink-0">
          <ShareButton recipeCardRef={recipeCardRef} />
        </div>

        {/* 🛡 Permissions */}
        <PermissionsSettings
          trigger={
            <button
              className="p-1.5 sm:p-2 py-3 h-11 rounded flex-shrink-0 hover:bg-soft-yellow/40 hover:text-rich-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
              aria-label="Manage permissions"
              title="Manage who can view or edit"
            >
              <ShieldCheckIcon className="h-5 w-5 sm:h-6 sm:w-6" />
            </button>
          }
        />

        {/* 🎛 Mobile - Utilities */}
        <button
          onClick={onOpenUtilities}
          className="lg:hidden p-1.5 sm:p-2 py-3 h-11 rounded flex-shrink-0 hover:bg-soft-yellow/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
          aria-label="Open utilities"
          title="Open utility tools"
        >
          <AdjustmentsHorizontalIcon className="h-5 w-5 sm:h-6 sm:w-6" />
        </button>

        {/* 👤 Avatar Menu */}
        <div className="flex-shrink-0">
          <UserMenu />
        </div>
      </div>
    </header>
  )
}

TopNavigation.propTypes = {
  onOpenLibrary: PropTypes.func.isRequired,
  onOpenUtilities: PropTypes.func.isRequired,
  recipeCardRef: PropTypes.object,
}
